module.exports = __webpack_public_path__ + "static/media/21.eed36ce3.svg";